import { COGNITO_CLIENT_ID, COGNITO_DOMAIN, REDIRECT_URI } from "../BaseUrl";

export const cognitoConfig = {
  domain: COGNITO_DOMAIN,
  clientId: COGNITO_CLIENT_ID,
  redirectUri: REDIRECT_URI,
  responseType: "code",
  scope: "openid profile email",
  provider: "Microsoft", // exact IdP name in Cognito
};
